// language=GraphQL
export const ALL_TRAVELLERS_QUERY = `query Query($withAgeGroup: Boolean = false, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withFamilyPackage: Boolean = false, $withFamilyPackageAccommodation: Boolean = false, $withFamilyPackageAccommodationCapacitySettings: Boolean = false, $withFamilyPackageAccommodationAddons: Boolean = false, $withFamilyPackageCapacitySettings: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackageAddons: Boolean = false, $withFamilyPackageAddonsCalculationSettings: Boolean = false, $withFamilyPackageAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAccommodationAddonsMandatorySettingsBusSettings: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withPersonalAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withPersonalAddonsMandatorySettingsBusSettings: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withBookingAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withBookingAddonsMandatorySettingsBusSettings: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPassportData: Boolean = false) {
  travellers: travellers {
    id
    salutation
    firstName
    lastName
    birthday
    nationality
    email
    phone
    address
    addressNumber
    addressAddition
    zip
    city
    country
    ageGroup @include(if: $withAgeGroup) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
    accommodation @include(if: $withAccommodation) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
      capacitySettings @include(if: $withAccommodationCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
    }
    familyPackage @include(if: $withFamilyPackage) {
      id
      ratioServiceNo
      accommodation @include(if: $withFamilyPackageAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withFamilyPackageAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withFamilyPackageAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      name
      label
      info
      capacitySettings @include(if: $withFamilyPackageCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withFamilyPackageAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withFamilyPackageAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withFamilyPackageAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
    }
    accommodationAddons @include(if: $withAccommodationAddons) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withAccommodationAddonsMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withAccommodationAddonsMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
    personalAddons @include(if: $withPersonalAddons) {
      id
      ratioServiceNo
      name
      label
      info
      allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withPersonalAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withPersonalAddonsMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withPersonalAddonsMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
    bookingAddons @include(if: $withBookingAddons) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withBookingAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withBookingAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withBookingAddonsMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withBookingAddonsMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
    extensions @include(if: $withExtensions) {
      id
      label
      info
      travelExtension @include(if: $withExtensionsTravelExtension) {
        id
        duration
        name
        description
        highlights @include(if: $withExtensionsTravelExtensionHighlights) {
          id
          text
        }
        image @include(if: $withExtensionsTravelExtensionImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {
        id
        baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
      }
    }
    passportData @include(if: $withPassportData) {
      id
      type
      number
      birthPlace
      issuePlace
      issueDate
      validUntil
    }
  }
}`

// language=GraphQL
export const SINGLE_TRAVELLER_QUERY = `query Query($id: ID!, $withAgeGroup: Boolean = false, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withFamilyPackage: Boolean = false, $withFamilyPackageAccommodation: Boolean = false, $withFamilyPackageAccommodationCapacitySettings: Boolean = false, $withFamilyPackageAccommodationAddons: Boolean = false, $withFamilyPackageCapacitySettings: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackageAddons: Boolean = false, $withFamilyPackageAddonsCalculationSettings: Boolean = false, $withFamilyPackageAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAccommodationAddonsMandatorySettingsBusSettings: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withPersonalAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withPersonalAddonsMandatorySettingsBusSettings: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withBookingAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withBookingAddonsMandatorySettingsBusSettings: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPassportData: Boolean = false) {
  traveller: traveller(id: $id) {
    id
    salutation
    firstName
    lastName
    birthday
    nationality
    email
    phone
    address
    addressNumber
    addressAddition
    zip
    city
    country
    ageGroup @include(if: $withAgeGroup) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
    accommodation @include(if: $withAccommodation) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
      capacitySettings @include(if: $withAccommodationCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
    }
    familyPackage @include(if: $withFamilyPackage) {
      id
      ratioServiceNo
      accommodation @include(if: $withFamilyPackageAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withFamilyPackageAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withFamilyPackageAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      name
      label
      info
      capacitySettings @include(if: $withFamilyPackageCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withFamilyPackageAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withFamilyPackageAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withFamilyPackageAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
    }
    accommodationAddons @include(if: $withAccommodationAddons) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withAccommodationAddonsMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withAccommodationAddonsMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
    personalAddons @include(if: $withPersonalAddons) {
      id
      ratioServiceNo
      name
      label
      info
      allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withPersonalAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withPersonalAddonsMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withPersonalAddonsMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
    bookingAddons @include(if: $withBookingAddons) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withBookingAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withBookingAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withBookingAddonsMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withBookingAddonsMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
    extensions @include(if: $withExtensions) {
      id
      label
      info
      travelExtension @include(if: $withExtensionsTravelExtension) {
        id
        duration
        name
        description
        highlights @include(if: $withExtensionsTravelExtensionHighlights) {
          id
          text
        }
        image @include(if: $withExtensionsTravelExtensionImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {
        id
        baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
      }
    }
    passportData @include(if: $withPassportData) {
      id
      type
      number
      birthPlace
      issuePlace
      issueDate
      validUntil
    }
  }
}`

// language=GraphQL
export const CREATE_TRAVELLER_MUTATION = `
  mutation Mutation($input: CreateTravellerInput, $withAgeGroup: Boolean = false, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withFamilyPackage: Boolean = false, $withFamilyPackageAccommodation: Boolean = false, $withFamilyPackageAccommodationCapacitySettings: Boolean = false, $withFamilyPackageAccommodationAddons: Boolean = false, $withFamilyPackageCapacitySettings: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackageAddons: Boolean = false, $withFamilyPackageAddonsCalculationSettings: Boolean = false, $withFamilyPackageAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAccommodationAddonsMandatorySettingsBusSettings: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withPersonalAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withPersonalAddonsMandatorySettingsBusSettings: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withBookingAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withBookingAddonsMandatorySettingsBusSettings: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPassportData: Boolean = false) {
    traveller: createTraveller(input: $input) {
      id
      salutation
      firstName
      lastName
      birthday
      nationality
      email
      phone
      address
      addressNumber
      addressAddition
      zip
      city
      country
      ageGroup @include(if: $withAgeGroup) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      accommodation @include(if: $withAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
      }
      familyPackage @include(if: $withFamilyPackage) {
        id
        ratioServiceNo
        accommodation @include(if: $withFamilyPackageAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withFamilyPackageAccommodationCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withFamilyPackageAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        name
        label
        info
        capacitySettings @include(if: $withFamilyPackageCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withFamilyPackageAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withFamilyPackageAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withFamilyPackageAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
      }
      accommodationAddons @include(if: $withAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
          useDateSwitch
          dateSwitchSettings @include(if: $withAccommodationAddonsMandatorySettingsDateSwitchSettings) {
            id
            startDateOffsetDays
            endDateOffsetDays
          }
          useBusSettings
          busSettings @include(if: $withAccommodationAddonsMandatorySettingsBusSettings) {
            id
            boardingSelectionEnabled
          }
        }
      }
      personalAddons @include(if: $withPersonalAddons) {
        id
        ratioServiceNo
        name
        label
        info
        allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withPersonalAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
          useDateSwitch
          dateSwitchSettings @include(if: $withPersonalAddonsMandatorySettingsDateSwitchSettings) {
            id
            startDateOffsetDays
            endDateOffsetDays
          }
          useBusSettings
          busSettings @include(if: $withPersonalAddonsMandatorySettingsBusSettings) {
            id
            boardingSelectionEnabled
          }
        }
      }
      bookingAddons @include(if: $withBookingAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withBookingAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withBookingAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
          useDateSwitch
          dateSwitchSettings @include(if: $withBookingAddonsMandatorySettingsDateSwitchSettings) {
            id
            startDateOffsetDays
            endDateOffsetDays
          }
          useBusSettings
          busSettings @include(if: $withBookingAddonsMandatorySettingsBusSettings) {
            id
            boardingSelectionEnabled
          }
        }
      }
      extensions @include(if: $withExtensions) {
        id
        label
        info
        travelExtension @include(if: $withExtensionsTravelExtension) {
          id
          duration
          name
          description
          highlights @include(if: $withExtensionsTravelExtensionHighlights) {
            id
            text
          }
          image @include(if: $withExtensionsTravelExtensionImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {
          id
          baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            extensionAccommodationServiceNo
          }
        }
      }
      passportData @include(if: $withPassportData) {
        id
        type
        number
        birthPlace
        issuePlace
        issueDate
        validUntil
      }
    }
  }`

// language=GraphQL
export const UPDATE_TRAVELLER_MUTATION = `
  mutation Mutation($input: UpdateTravellerInput, $withAgeGroup: Boolean = false, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withFamilyPackage: Boolean = false, $withFamilyPackageAccommodation: Boolean = false, $withFamilyPackageAccommodationCapacitySettings: Boolean = false, $withFamilyPackageAccommodationAddons: Boolean = false, $withFamilyPackageCapacitySettings: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackageAddons: Boolean = false, $withFamilyPackageAddonsCalculationSettings: Boolean = false, $withFamilyPackageAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAccommodationAddonsMandatorySettingsBusSettings: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withPersonalAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withPersonalAddonsMandatorySettingsBusSettings: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withBookingAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withBookingAddonsMandatorySettingsBusSettings: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPassportData: Boolean = false) {
    traveller: updateTraveller(input: $input) {
      id
      salutation
      firstName
      lastName
      birthday
      nationality
      email
      phone
      address
      addressNumber
      addressAddition
      zip
      city
      country
      ageGroup @include(if: $withAgeGroup) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      accommodation @include(if: $withAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
      }
      familyPackage @include(if: $withFamilyPackage) {
        id
        ratioServiceNo
        accommodation @include(if: $withFamilyPackageAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withFamilyPackageAccommodationCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withFamilyPackageAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        name
        label
        info
        capacitySettings @include(if: $withFamilyPackageCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withFamilyPackageAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withFamilyPackageAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withFamilyPackageAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
      }
      accommodationAddons @include(if: $withAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
          useDateSwitch
          dateSwitchSettings @include(if: $withAccommodationAddonsMandatorySettingsDateSwitchSettings) {
            id
            startDateOffsetDays
            endDateOffsetDays
          }
          useBusSettings
          busSettings @include(if: $withAccommodationAddonsMandatorySettingsBusSettings) {
            id
            boardingSelectionEnabled
          }
        }
      }
      personalAddons @include(if: $withPersonalAddons) {
        id
        ratioServiceNo
        name
        label
        info
        allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withPersonalAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
          useDateSwitch
          dateSwitchSettings @include(if: $withPersonalAddonsMandatorySettingsDateSwitchSettings) {
            id
            startDateOffsetDays
            endDateOffsetDays
          }
          useBusSettings
          busSettings @include(if: $withPersonalAddonsMandatorySettingsBusSettings) {
            id
            boardingSelectionEnabled
          }
        }
      }
      bookingAddons @include(if: $withBookingAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withBookingAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withBookingAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
          useDateSwitch
          dateSwitchSettings @include(if: $withBookingAddonsMandatorySettingsDateSwitchSettings) {
            id
            startDateOffsetDays
            endDateOffsetDays
          }
          useBusSettings
          busSettings @include(if: $withBookingAddonsMandatorySettingsBusSettings) {
            id
            boardingSelectionEnabled
          }
        }
      }
      extensions @include(if: $withExtensions) {
        id
        label
        info
        travelExtension @include(if: $withExtensionsTravelExtension) {
          id
          duration
          name
          description
          highlights @include(if: $withExtensionsTravelExtensionHighlights) {
            id
            text
          }
          image @include(if: $withExtensionsTravelExtensionImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {
          id
          baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            extensionAccommodationServiceNo
          }
        }
      }
      passportData @include(if: $withPassportData) {
        id
        type
        number
        birthPlace
        issuePlace
        issueDate
        validUntil
      }
    }
  }`

// language=GraphQL
export const DELETE_TRAVELLER_MUTATION = `
  mutation Mutation($input: DeleteTravellerInput) {
    deleteTraveller(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TRAVELLER_MUTATION = `
  mutation Mutation($input: DeleteTravellerInput) {
    forceDeleteTraveller(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_TRAVELLER_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: addTravellerAccommodationAddonsInput) {
    addTravellerAccommodationAddons(input: $input) {
      id
      accommodationAddonIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVELLER_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: removeTravellerAccommodationAddonsInput) {
    removeTravellerAccommodationAddons(input: $input) {
      id
      accommodationAddonIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVELLER_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: createTravellerAccommodationAddonsInput) {
    createTravellerAccommodationAddons(input: $input) {
      id
      accommodationAddonIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVELLER_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: deleteTravellerAccommodationAddonsInput) {
    deleteTravellerAccommodationAddons(input: $input) {
      id
      accommodationAddonIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVELLER_ACCOMMODATION_ADDONS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravellerAccommodationAddonsOrderInput) {
    updateTravellerAccommodationAddonsOrder(input: $input) {
      id
      accommodationAddonIds
    }
  }`

// language=GraphQL
export const ADD_TRAVELLER_PERSONAL_ADDONS_MUTATION = `
  mutation Mutation($input: addTravellerPersonalAddonsInput) {
    addTravellerPersonalAddons(input: $input) {
      id
      personalAddonIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVELLER_PERSONAL_ADDONS_MUTATION = `
  mutation Mutation($input: removeTravellerPersonalAddonsInput) {
    removeTravellerPersonalAddons(input: $input) {
      id
      personalAddonIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVELLER_PERSONAL_ADDONS_MUTATION = `
  mutation Mutation($input: createTravellerPersonalAddonsInput) {
    createTravellerPersonalAddons(input: $input) {
      id
      personalAddonIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVELLER_PERSONAL_ADDONS_MUTATION = `
  mutation Mutation($input: deleteTravellerPersonalAddonsInput) {
    deleteTravellerPersonalAddons(input: $input) {
      id
      personalAddonIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVELLER_PERSONAL_ADDONS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravellerPersonalAddonsOrderInput) {
    updateTravellerPersonalAddonsOrder(input: $input) {
      id
      personalAddonIds
    }
  }`

// language=GraphQL
export const ADD_TRAVELLER_BOOKING_ADDONS_MUTATION = `
  mutation Mutation($input: addTravellerBookingAddonsInput) {
    addTravellerBookingAddons(input: $input) {
      id
      bookingAddonIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVELLER_BOOKING_ADDONS_MUTATION = `
  mutation Mutation($input: removeTravellerBookingAddonsInput) {
    removeTravellerBookingAddons(input: $input) {
      id
      bookingAddonIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVELLER_BOOKING_ADDONS_MUTATION = `
  mutation Mutation($input: createTravellerBookingAddonsInput) {
    createTravellerBookingAddons(input: $input) {
      id
      bookingAddonIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVELLER_BOOKING_ADDONS_MUTATION = `
  mutation Mutation($input: deleteTravellerBookingAddonsInput) {
    deleteTravellerBookingAddons(input: $input) {
      id
      bookingAddonIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVELLER_BOOKING_ADDONS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravellerBookingAddonsOrderInput) {
    updateTravellerBookingAddonsOrder(input: $input) {
      id
      bookingAddonIds
    }
  }`

// language=GraphQL
export const ADD_TRAVELLER_EXTENSIONS_MUTATION = `
  mutation Mutation($input: addTravellerExtensionsInput) {
    addTravellerExtensions(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVELLER_EXTENSIONS_MUTATION = `
  mutation Mutation($input: removeTravellerExtensionsInput) {
    removeTravellerExtensions(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVELLER_EXTENSIONS_MUTATION = `
  mutation Mutation($input: createTravellerExtensionsInput) {
    createTravellerExtensions(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVELLER_EXTENSIONS_MUTATION = `
  mutation Mutation($input: deleteTravellerExtensionsInput) {
    deleteTravellerExtensions(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVELLER_EXTENSIONS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravellerExtensionsOrderInput) {
    updateTravellerExtensionsOrder(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const TRAVELLERS_DEPENDENTS_QUERY = `query Query($id: ID!, $withBookings: Boolean = false) {
  groupedDependents: travellerDependents(id: $id) {
    bookings @include(if: $withBookings) {
      id
      referenceNo
      travellerRemarks
      travellerDataCorrectnessConfirmation
      localState
      backofficePayload
      backofficeResponse
      transmissionStatus
      webhookStatus
      webhookResponse
      webhookDuration
      confirmationEmailSent
      isPassportDataRequired
      passportDataReminderEmailSent
      passportDataReceived
      newsletterRegistrationSubmittedAt    }
  }
}`
